var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCoding18Line = function SvgIconCoding18Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.27 12.961-2.82-2.674a1.084 1.084 0 0 1 0-1.575L6.27 6.04l.878.926L4.47 9.504l2.678 2.539-.878.926v-.008ZM11.73 12.961l-.878-.926 2.678-2.539-2.678-2.539.878-.926 2.82 2.674a1.084 1.084 0 0 1 0 1.575l-2.82 2.674v.007ZM8.958 6.065l-1.171 6.647 1.255.221 1.171-6.647-1.255-.221Z",
    fill: "current"
  })));
};
export default SvgIconCoding18Line;